export const MACHINE_SETUP_CARD_PAYMENT_ONLY = {
	YES: 'yes',
	NO: 'no',
};

export const MACHINE_SETUP_CARD_PAYMENT_ONLY_OPTIONS = [
	{ label: 'Yes', value: MACHINE_SETUP_CARD_PAYMENT_ONLY.YES },
	{ label: 'No', value: MACHINE_SETUP_CARD_PAYMENT_ONLY.NO },
];

export const MACHINE_SETUP_CARD_PAYMENT_ONLY_HINT = 'Choose Yes for card payments only. Choose No to install card, coin and note payment systems.';

export const getMachineSetupCardPaymentOnlyChoice = ({
	requiresCreditCardReader,
	requiresCashPayments,
} = {}) => {
	if (requiresCreditCardReader === true && requiresCashPayments === false) {
		return MACHINE_SETUP_CARD_PAYMENT_ONLY.YES;
	}

	if (requiresCreditCardReader === true && requiresCashPayments === true) {
		return MACHINE_SETUP_CARD_PAYMENT_ONLY.NO;
	}

	return null;
};

export const getMachineSetupPaymentRequirements = (cardPaymentOnlyChoice) => {
	if (cardPaymentOnlyChoice === MACHINE_SETUP_CARD_PAYMENT_ONLY.YES) {
		return {
			requiresCreditCardReader: true,
			requiresCashPayments: false,
		};
	}

	if (cardPaymentOnlyChoice === MACHINE_SETUP_CARD_PAYMENT_ONLY.NO) {
		return {
			requiresCreditCardReader: true,
			requiresCashPayments: true,
		};
	}

	return null;
};

export const hasMachineSetupPaymentDevices = ({
	requiresCreditCardReader,
	requiresCashPayments,
} = {}) => requiresCreditCardReader === true || requiresCashPayments === true;

const getRequirementLabel = (value) => {
	if (value === true) {
		return 'Yes';
	}

	if (value === false) {
		return 'No';
	}

	return 'Not specified';
};

export const getMachineSetupCardPaymentOnlyDisplay = (machineSetup) => {
	const choice = getMachineSetupCardPaymentOnlyChoice(machineSetup);

	if (choice === MACHINE_SETUP_CARD_PAYMENT_ONLY.YES) {
		return 'Yes — card payments only';
	}

	if (choice === MACHINE_SETUP_CARD_PAYMENT_ONLY.NO) {
		return 'No — card, coin and note payments';
	}

	const hasSpecifiedRequirement = (
		typeof machineSetup?.requiresCreditCardReader === 'boolean' ||
		typeof machineSetup?.requiresCashPayments === 'boolean'
	);
	const prefix = hasSpecifiedRequirement ? 'Custom setup' : 'Not specified';

	return `${prefix} — Card: ${getRequirementLabel(machineSetup?.requiresCreditCardReader)}; cash: ${getRequirementLabel(machineSetup?.requiresCashPayments)}`;
};
